// OAuth Callback Handler Component

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingSpinner from './common/LoadingSpinner';
import './OAuthCallback.css';

const OAuthCallback = () => {
    const navigate = useNavigate();
    const [status, setStatus] = useState('processing');

    useEffect(() => {
        const handleCallback = () => {
            // Extract token from URL hash
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.substring(1));
            const token = params.get('access_token');
            const error = params.get('error');

            if (error) {
                setStatus('error');
                setTimeout(() => navigate('/settings'), 3000);
                return;
            }

            if (token) {
                // If opened in popup, send token to opener
                if (window.opener && !window.opener.closed) {
                    window.opener.postMessage({
                        type: 'OAUTH_SUCCESS',
                        token
                    }, window.location.origin);
                    setStatus('success');
                    setTimeout(() => window.close(), 2000);
                }
                // If in same tab, store token (obfuscated) and redirect
                else {
                    const { savePendingToken } = require('../services/tokenStorage');
                    savePendingToken(token);
                    setStatus('success');
                    setTimeout(() => navigate('/settings'), 2000);
                }
            } else {
                setStatus('error');
                setTimeout(() => navigate('/settings'), 3000);
            }
        };

        handleCallback();
    }, [navigate]);

    return (
        <div className="oauth-callback-container">
            {status === 'processing' && (
                <div className="callback-content">
                    <LoadingSpinner size="large" message="" />
                    <h2>Connecting to AniList...</h2>
                    <p>Please wait while we complete the authorization</p>
                </div>
            )}

            {status === 'success' && (
                <div className="callback-content success">
                    <div className="success-icon">✓</div>
                    <h2>Successfully Connected!</h2>
                    <p>Redirecting you back to settings...</p>
                </div>
            )}

            {status === 'error' && (
                <div className="callback-content error">
                    <div className="error-icon">✗</div>
                    <h2>Authorization Failed</h2>
                    <p>Redirecting you back to settings...</p>
                </div>
            )}
        </div>
    );
};

export default OAuthCallback;
